import React from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner, Alert, Image, Accordion, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TemplateOfertaDireta = ({
    entidade,
    servico,
    formData,
    submitStatus,
    isLoading,
    handleChange,
    handleSubmit,
}) => {
    return (
        <>
            {/* Seção Hero com Oferta Direta */}
            <section className="py-5" style={{ background: 'linear-gradient(45deg, #0d6efd, #6f42c1)' }}>
                <Container className="text-white">
                    <Row className="align-items-center">
                        <Col lg={6} className="text-center text-lg-start mb-5 mb-lg-0">
                            <h1 className="display-3 fw-bold">{servico.titulo_oferta}</h1>
                            <div className="price-tag-offer my-4 justify-content-center justify-content-lg-start">
                                <span className="price-old">{servico.preco_antigo}</span>
                                <span className="price-new">{servico.preco_novo}</span>
                            </div>
                            <p className="lead">{servico.texto_urgencia}</p>
                            <hr className="my-4" />
                            <h3 className="h5">{servico.titulo_hero}</h3>
                            <p>{servico.subtitulo_hero}</p>
                        </Col>
                        <Col lg={6} id="form-top">
                            <Card className="p-4 shadow-lg">
                                <Card.Body>
                                    {submitStatus.submitted ? (
                                        <Alert variant={submitStatus.variant} className="text-center">
                                            <Alert.Heading>{submitStatus.variant === 'success' ? 'Obrigado!' : 'Ops!'}</Alert.Heading>
                                            <p className="mb-0">{submitStatus.message}</p>
                                        </Alert>
                                    ) : (
                                        <>
                                            <h4 className="text-center mb-4">Garanta sua Vaga!</h4>
                                            <p className="text-center text-muted small">Preencha seus dados para aproveitar esta condição especial.</p>
                                            <Form onSubmit={handleSubmit}>
                                                <InputGroup className="mb-3">
                                                    <InputGroup.Text><FontAwesomeIcon icon="user" /></InputGroup.Text>
                                                    <Form.Control type="text" name="nome" placeholder="Nome Completo" value={formData.nome} onChange={handleChange} required />
                                                </InputGroup>
                                                <InputGroup className="mb-3">
                                                    <InputGroup.Text><FontAwesomeIcon icon="phone" /></InputGroup.Text>
                                                    <Form.Control type="tel" name="telefone" placeholder="Telefone / WhatsApp" value={formData.telefone} onChange={handleChange} required />
                                                </InputGroup>
                                                <InputGroup className="mb-3">
                                                    <InputGroup.Text><FontAwesomeIcon icon="envelope" /></InputGroup.Text>
                                                    <Form.Control type="email" name="email" placeholder="Seu melhor e-mail" value={formData.email} onChange={handleChange} required />
                                                </InputGroup>
                                                <div className="d-grid"><Button variant="primary" type="submit" size="lg" disabled={isLoading}>{isLoading ? <Spinner as="span" size="sm" /> : "Eu Quero Essa Oferta!"}</Button></div>
                                            </Form>
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Seção de Benefícios */}
            <section className="py-5 bg-light">
                <Container>
                    <h2 className="text-center mb-5">{servico.titulo_beneficios}</h2>
                    <Row>
                        {servico.lista_beneficios.map((beneficio, index) => (
                            <Col md={4} key={index} className="mb-4">
                                <div className="d-flex">
                                    <div className="display-4 me-3 text-primary">{beneficio.icone}</div>
                                    <div>
                                        <h5 className="fw-bold">{beneficio.titulo}</h5>
                                        <p className="text-muted">{beneficio.descricao}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Seção Antes e Depois */}
            {servico.imagens_antes_depois && servico.imagens_antes_depois.length > 0 && (
                <section className="py-5">
                    <Container>
                        <h2 className="text-center mb-5">{servico.titulo_antes_depois}</h2>
                        <Row className="g-4">
                            {servico.imagens_antes_depois.map((img, index) => (
                                <Col md={6} key={index}>
                                    <Row className="g-0 border rounded shadow-sm">
                                        <Col><Image src={img.antes} fluid /></Col>
                                        <Col><Image src={img.depois} fluid /></Col>
                                    </Row>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
            )}

            {/* A seção de FAQ pode ser omitida ou mantida, dependendo da estratégia */}

        </>
    );
};

export default TemplateOfertaDireta;
